import React from "react";
import { IconButton, Box } from "..";
import ChevronBigDown from "@tiny/icons/generated/ChevronBigDown";
import ChevronBigUp from "@tiny/icons/generated/ChevronBigUp";
import { ExpandButtonProps } from "./ExpandButton.types";
import { useStyles } from "./ExpandButton.styles";

function ExpandButton(props: ExpandButtonProps) {
  const { expanded, onClick, ...boxProps } = props;

  const classes = useStyles();

  return (
    <Box {...boxProps} display="inline">
      <IconButton className={classes.root} onClick={onClick} size="small">
        {expanded ? <ChevronBigUp /> : <ChevronBigDown />}
      </IconButton>
    </Box>
  );
}

export default ExpandButton;
